import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedCategories: [],
  selectedBrands: [],
  searchQuery: "", // Yeni eklendi
};

const categoryBrandSlice = createSlice({
  name: "categoryBrand",
  initialState,
  reducers: {
    addCategory: (state, action) => {
      state.selectedCategories.push(action.payload);
    },
    addBrand: (state, action) => {
      state.selectedBrands.push(action.payload);
    },
    removeCategory: (state, action) => {
      state.selectedCategories = state.selectedCategories.filter(
        (id) => id !== action.payload
      );
    },
    removeBrand: (state, action) => {
      state.selectedBrands = state.selectedBrands.filter(
        (id) => id !== action.payload
      );
    },
    clearCategories: (state) => {
      state.selectedCategories = [];
    },
    clearBrands: (state) => {
      state.selectedBrands = [];
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload; // Yeni eklendi
    },
  },
});

export const {
  addCategory,
  removeCategory,
  clearCategories,
  addBrand,
  removeBrand,
  clearBrands,
  setSearchQuery, // Yeni eklendi
} = categoryBrandSlice.actions;

export default categoryBrandSlice.reducer;
